import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';

const GlemtPassord = () => {
  const [epost, setEpost] = useState('');
  const [busy, setBusy] = useState(false);
  const [sendt, setSendt] = useState(false);
  const [feil, setFeil] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setFeil(''); setBusy(true);
    try {
      await api.post('/auth/glemt-passord', { epost });
      setSendt(true);
    } catch (err) {
      setFeil(err.response?.data?.error || 'Noe gikk galt. Prøv igjen.');
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: 'var(--theme-bg-primary)', padding: 16 }}>
      <div className="card" style={{ width: '100%', maxWidth: 380, padding: 28 }}>
        <div className="flex items-center justify-center" style={{ marginBottom: 20 }}>
          <img src="/logo.png" alt="REGNINO" style={{ height: 48, width: 'auto', maxWidth: '100%', objectFit: 'contain' }} />
        </div>
        <h2 style={{ textAlign: 'center', marginBottom: 14, fontSize: 18 }}>Glemt passord</h2>
        {sendt ? (
          <>
            <div className="badge badge-success" style={{ width: '100%', justifyContent: 'center', padding: 10, marginBottom: 14 }}>
              Hvis e-postadressen er registrert har vi sendt deg en lenke for å sette nytt passord.
            </div>
            <div style={{ textAlign: 'center', fontSize: 13 }}>
              Sjekk innboks (og søppelpost). Lenken er gyldig i 1 time.
            </div>
            <div style={{ textAlign: 'center', marginTop: 18, fontSize: 13 }}>
              <Link to="/login">Tilbake til innlogging</Link>
            </div>
          </>
        ) : (
          <form onSubmit={onSubmit}>
            <p className="fm-text-muted" style={{ fontSize: 13, marginBottom: 12, textAlign: 'center' }}>
              Skriv inn e-postadressen din, så sender vi en lenke for å sette nytt passord.
            </p>
            <label>E-post</label>
            <input type="email" value={epost} onChange={(e) => setEpost(e.target.value)}
                   autoFocus required style={{ marginBottom: 10 }} />
            {feil && (
              <div className="badge badge-danger" style={{ width: '100%', justifyContent: 'center', padding: 8, marginBottom: 12 }}>
                {feil}
              </div>
            )}
            <button type="submit" disabled={busy} className="btn-primary"
                    style={{ width: '100%', height: 36, justifyContent: 'center' }}>
              {busy ? 'Sender…' : 'Send lenke'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 14, fontSize: 12 }}>
              <Link to="/login">Tilbake til innlogging</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default GlemtPassord;
